<script>
    export let isUp = false;
</script>

<div style="width: 12px;" class="tw-transition-transform tw-duration-500 tw-ease-in-out tw-transform {isUp? 'tw-rotate-180' : ''} tw-text-gray-200">
    <svg focusable="false" role="presentation" viewBox="0 0 28 16">
        <path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path>
    </svg>
</div>